/*@flow*/
import type { Node } from 'react';
import React, { useEffect, useState, createRef, useContext } from 'react';
import useAutocomplete from 'lib/useAutocomplete';
import Blank from 'lib/Blank';
import CountryDropdown from './CountryDropdown';
import LocateMeButton from './LocateMeButton';
import RevGeocodeButton from './RevGeocodeButton';
import context from './context';
import commands from './commands';
import usePrev from 'lib/usePrev';
import same from 'lib/same';

// function selectAll(element) {
//   element.selectionStart = 0;
//   element.selectionEnd = element.value.length;
// }

export default (): Node => {
  const ctx = useContext(context);
  const [isEditing, setEditing] = useState(false);
  const { state } = ctx;
  const ref = createRef();
  const { googPlace, apiRef } = useAutocomplete(ref);

  const prevGoogPlace = usePrev(googPlace);

  useEffect(() => {
    if (Blank.is(googPlace)) return;
    if (isEditing && ctx.state.fullAddress) return;
    if (same(prevGoogPlace, googPlace)) return;
    commands(ctx).setPlace(googPlace);
  }, [
    prevGoogPlace,
    googPlace,
    ctx.state.fullAddress,
    ctx.state.theGeom,
    isEditing,
  ]);

  useEffect(() => {
    const cur = ref.current;
    if (!cur) return;
    ((cur: any): HTMLInputElement).value = state.fullAddress || '';
  }, [state.fullAddress]);

  function onChange(e) {
    commands(ctx).setFullAddress(e.target.value);
  }

  function onFocus() {
    setEditing(true);
  }

  function onBlur() {
    setEditing(false);
  }

  return (
    <React.Fragment>
      <input
        ref={ref}
        placeholder="Enter an address"
        value={state.fullAddress || ''}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        autoComplete="off"
        data-testid="SearchAddress"
        name={state.name}
        className="form-control form-control-lg enter-an-address"
      />
      <div className="mb-4 mt-2">
        <LocateMeButton />
        <RevGeocodeButton className="ml-4" />
        <CountryDropdown apiRef={apiRef} />
      </div>
    </React.Fragment>
  );
};
